// extracted by mini-css-extract-plugin
export var childrenContainer = "_cn-0";
export var virtualScrollArea = "_cn-1";